<template>
<div class="chapter">
<div class="inner_page">
<div class="titlePage" id="tp01">
<a id="page07"></a>
<h2 class="titlePageTitle">An Almost Perfect Moment</h2>
<h2 class="titlePageAuthor">Binnie Kirshenbaum</h2>
<p class="colophon"><img alt="image" src="images/logo.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?3e4d175e